// extracted by mini-css-extract-plugin
export default {"addVisibleFieldTag":"RegistrationTemplateForm_addVisibleFieldTag__JBptv","disabledAddVisibleFieldTag":"RegistrationTemplateForm_disabledAddVisibleFieldTag__A3ma7"};